import { SubTopicListItem } from '@all-manager/design-system-v2';
import type { SubTopicDatabase } from '../../../../types';
import type { TopicListPage } from '../../pages/useTopicListPage';
import SubTopicActions from '../SubTopicActions/SubTopicActions';
import SubTopicState from '../SubTopicState/SubTopicState';

type Props = {
  page: TopicListPage;
  subTopic: SubTopicDatabase;
};

export default function SubTopicRow(props: Props) {
  const page = props.page;

  return (
    <SubTopicListItem
      name={props.subTopic.name}
      href={page.getSubTopicHref(props.subTopic.id)}
      onClick={page.getSubTopicClickHandler(props.subTopic.id)}
      status={<SubTopicState item={props.subTopic} />}
      archived={!!props.subTopic.archived_at}
      action={page.isAdmin ? <SubTopicActions subTopic={props.subTopic} size="small" /> : undefined}
    />
  );
}
